import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SearchSubProject from '../../components/forms/searchSubProject/SearchSubProject'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import {
  getProgresstothaihealthFormReportSubmitPdf,
  getProgresstomanagerFormReportSubmitPdf,
  getProgressivebyperiodFormReportSubmitPdf,
} from '../../redux/actions/subProjectReport'

export default function ProgressiveReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [previewPdf, setPreviewPdf] = useState()
  const [reportType, setReportType] = useState('ProgressiveReport')
  const [mainProjectOption, setMainProjectOption] = useState([])
  const [subProjectOption, setSubProjectOption] = useState([])
  const [dateReportOption, setDateReportOption] = useState([])
  const [periodNoOption, setPeriodNoOption] = useState([])
  const [stype, setStype] = useState(null)

  useEffect(() => {
    console.log('load ProjectName projectId')
    //พี่ตุ๊ให้เอาปุ่มแสดงตัวอย่างก่อนพิมพ์ออก
    // formSchema.buttonText.previewButtonName = 'แสดงตัวอย่างก่อนพิมพ์'
    buttonDisabled()
  }, [])

  const buttonDisabled = () => {
    const disValue = {
      buttonText: formSchema.buttonText.disabled,
    }

    setDisableValue(disValue)
  }

  const handleDownloadPdf = async (data) => {
    console.log('ddddd => ', data)

    const response = await handleCallReportSubmitPdf(data)
    // console.log('response => ', response)
    let fileName = data.subProjectOption || ''
    switch (data.progressiveReport) {
      case 'progressiveReportToManager':
        fileName = 'แบบรายงานความก้าวหน้าโครงการ'
        break

      default:
        break
    }
    await onDownload(response, fileName)
  }

  const onDownload = async (fileObj, fileName) => {
    if (fileObj) {
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }

  const handleCheangMainProject = (projectId) => {

    const mainProject = mainProjectOption.find((mainProject) => mainProject.value === projectId)

    if (mainProject.dateReport) {
//      console.log('typeeee => ', stype)
//      console.log('date => ', mainProject.dateReport)

      let newArr = []
      if(stype == 'progressiveReportToThaihealth'){
//        console.log('count => ', mainProject.dateReport.length)

        if( mainProject.dateReport.length > 0){
          newArr = mainProject.dateReport.reduce((acc, current) => {
            const x = acc.find(item => item.value === current.value);
            if (!x) {
              acc.push(current);
            }
            return acc;
          }, []);
        }

      }else {
        newArr = mainProject.dateReport
      }

      setDateReportOption(newArr)
    }

    if (mainProject.subProject) {
      setSubProjectOption(mainProject.subProject)
    }

    const disValue = {
      buttonText: mainProject.dateReport ? false : true,
      subProjectOption: false,
      dateReportOption: mainProject.dateReport ? false : true,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }
    setDisableValue(disValue)
  }

  const handleChangeSubProject = (subProjectId) => {
    const subProject = subProjectOption.find((mainProject) => mainProject.value === subProjectId)

    if (subProject.dateReport) {
      setDateReportOption(subProject.dateReport)
    }

    if (subProject.periodNo) {
      setPeriodNoOption(subProject.periodNo)
    }

    const disValue = {
      buttonText: true,
      subProjectOption: false,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
    }
    setDisableValue(disValue)
    // setIsSucceed(true)
  }

  const handleChangProgressiveReportSet = (reportType) => {
//    console.log('reportType => ', reportType)
    setStype(reportType)
    const progressive = formSchema.valuesObject.progressive.find(
      (progressive) => progressive.value === reportType
    )
    setMainProjectOption(progressive.mainProject)
    setReportType(null)

    const disValue = {
      buttonText: true,
      subProjectOption: true,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
      dateReportOption: true,
      periodNoOption: true,
    }
    setDisableValue(disValue)
  }

  const handleChangePeriodNo = (no) => {
    const disValue = {
      buttonText: false,
    }
    setDisableValue(disValue)
  }

  const handleChangDateReport = (date) => {
    // console.log('date ', date)

    const disValue = {
      buttonText: false,
    }
    setDisableValue(disValue)
  }

  const handleCancel = () => {
    setIsSucceed(false)
    setPreviewPdf(null)
    setReportType('isCancel')
    setStype(null)
    for (const key in getValues()) {
      setValue(key, null)
    }
    buttonDisabled()
  }

  const handlePreviewPdf = async (data) => {
    await handleCallReportSubmitPdf(data)
    setIsSucceed(true)
    setStype(null)
  }

  const handleCallReportSubmitPdf = async (data) => {
    // console.log('data => ', data)
    // return false
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)

    try {
      let response

      switch (data.progressiveReport) {
        case 'progressiveReportToThaihealth':
          response = await getProgresstothaihealthFormReportSubmitPdf(
            data.mainProjectOption,
            data.dateReportOption
          )
          break

        case 'progressiveReportToManager':
          response = await getProgresstomanagerFormReportSubmitPdf(
            data.subProjectOption,
            data.dateReportOption
          )
          break

        case 'progressiveReportByPeriodNo':
          response = await getProgressivebyperiodFormReportSubmitPdf(
            data.subProjectOption,
            data.periodNoOption
          )
          break

        default:
          break
      }

      // console.log('ressss => ', response)

      if (response) {
        // setPreviewPdf(response)
        setIsPdfError(false)
        setIsLoadingPDF(false)
        doneLoading()
        return response
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error(e)
      setIsPdfError(true)
    }

    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <SearchSubProject
            schema={formSchema}
            mainProjectOption={mainProjectOption}
            dateReportOption={dateReportOption}
            subProjectOption={subProjectOption}
            periodNoOption={periodNoOption}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onChangProgressiveReportSet={handleChangProgressiveReportSet}
            onChangeMainProject={handleCheangMainProject}
            onChangeSubProject={handleChangeSubProject}
            onChangePeriodNo={handleChangePeriodNo}
            onchangeDateReport={handleChangDateReport}
            disabledValue={disabledValue}
            reportType={reportType}
          />
        )}

        <hr />

        <ButtonPanelWidget
          isDisabled={disabledValue.buttonText}
          isEdit={isEdit}
          isError={isError}
          buttonText={formSchema.buttonText}
          onPrint={handleSubmit(handleDownloadPdf)}
          onPreview={handleSubmit(handlePreviewPdf)}
          onCancel={(el) => {
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>

      <br />

      {/* setPreviewPdf */}
      {isSucceed && (
        <Panel
          shaded
          header={formSchema.reportName}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message showIcon type="error" description={'ยืนยันไม่สำเร็จ'} />
            </Row>
          )}

          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <>
              <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
              {/* <PdfRenderWidgets
                file={previewPdf}
                isLoading={isLoadingPDF}
                onReload={() => handleGetProjectSubmitPdf(projectId)}
              /> */}
            </>
          )}
        </Panel>
      )}
    </>
  )
}
